import FanEventPage from "./FanEventPage";

export default FanEventPage;
